import { serializable, alias, primitive } from 'serializr';
import { UserRole } from '../enums/userEnums';

export class Role {
  @serializable(alias('id', primitive()))
  id?: string;

  @serializable(alias('role', primitive()))
  role!: UserRole;
}
